import { Button, Clickable, Col, Row, Text } from 'components';
import { theme } from 'lib';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const Paragraph = styled(Text)`
  width: 430px;
  margin-top: 12px;
  font-size: 28px;
  line-height: 32px;

  ${(props) =>
    props.isMobile &&
    `
    width: 148px;
    margin-top: 8px;
    margin-bottom: 8px;
    font-size: 20px;
    line-height: 26px;
  `}
`;

const OpacityWrapper = styled.div`
  position: ${(props) => (props.isActive ? 'relative' : 'absolute')};
  opacity: ${(props) => (props.isActive ? 1 : 0)};
  transition: opacity 0.65s;
  top: 0;
  left: ${(props) => props.left || 0};
  z-index: ${(props) => (props.isActive ? 4 : 0)};
`;

const Image = styled.img`
  ${(props) =>
    props.isMobile &&
    `
    width: 221px;
  `}
`;

const Dot = styled.div`
  height: 10.14px;
  width: 10.14px;
  background-color: ${(props) => (props.selected ? theme.SECONDARY : 'black')};
  border-radius: 50%;
  margin-left: 5.79px;
  display: inline-block;
`;

let timer;
const FadeInSlider = ({ headerTitle, headerText, sliderElements, hideMobileHeader }) => {
  const { isMobile } = useSelector((state) => state.appState),
    [current, setCurrent] = useState(0),
    navigate = useNavigate(),
    { t } = useTranslation();

  useEffect(() => {
    timer = setInterval(() => {
      sliderForward();
    }, 4000);
  }, []);

  function handleChange(key) {
    clearInterval(timer);
    setCurrent(key);

    timer = setInterval(() => {
      sliderForward();
    }, 4000);
  }

  if (!headerText) {
    headerText = ['', '', '', ''];
  }

  function sliderForward() {
    //setCurrent(x => (x + 1) % sliderElements.length)
  }

  return (
    <Col
      wid={isMobile ? '100vw' : '100%'}
      ht={isMobile ? '700px' : '730px'}
      center
      centerAll
      marg={isMobile}
    >
      {isMobile && (
        <Row centerAll marg="0 39px">
          <Text size="24px" lineHt="30px" center>
            {headerText[0]}
          </Text>
        </Row>
      )}

      <Row wid={isMobile ? 'calc(100vw - 26px)' : '1140px'} start pad={isMobile && '45px 13px 0'}>
        <Col marg="13px 0 0" noFlex>
          {!isMobile && (
            <React.Fragment>
              <Col marg="0 0 12px 0">{headerTitle}</Col>

              <Paragraph isMobile={isMobile}>{headerText[0]}</Paragraph>
            </React.Fragment>
          )}

          {headerText.slice(1, headerText.length).map((x, i) => (
            <Paragraph isMobile={isMobile} key={i}>
              {x}
            </Paragraph>
          ))}
        </Col>

        <Col
          pos="relative"
          marg={isMobile ? '4px 0 0 15px' : '0 0 0 48px'}
          top={!isMobile && '-21px'}
        >
          {sliderElements.map((x, i) => (
            <Col start noFlex key={i}>
              <OpacityWrapper isActive={i === current}>
                <Image isMobile={isMobile} src={x.image} alt="" />

                <Row centerAll marg="4px 53px 0 0">
                  {!isMobile &&
                    current === i &&
                    sliderElements.map((x, i) => (
                      <Clickable onClick={() => handleChange(i)} key={i}>
                        <Dot selected={i === current} />
                      </Clickable>
                    ))}
                </Row>
              </OpacityWrapper>
            </Col>
          ))}
        </Col>

        {!isMobile && (
          <Col pos="relative" wid="260px" pad="0 13px" marg="0 0 0 36px">
            {sliderElements.map((x, i) => (
              <OpacityWrapper key={i} isActive={i === current} left={i !== current && '13px'}>
                <Row wid="100%" center>
                  <Text size="42px" med lineHt="110%" wid="">
                    {x.title}
                  </Text>
                </Row>

                <Text marg="12px 0 0" size="28px" lineHt="32px">
                  {x.content}
                </Text>

                <Button
                  marg="30px 0 0"
                  text={t('website.signUp')}
                  website
                  wid="178px"
                  ht="54px"
                  onClick={() => navigate('/signup')}
                  textStyle={{
                    style: {
                      fontSize: 24
                    }
                  }}
                />
              </OpacityWrapper>
            ))}
          </Col>
        )}
      </Row>

      {isMobile && (
        <Col pos="relative" wid="(100vw - 26px)" pad="0 13px" marg="-4px 0 0">
          {sliderElements.map((x, i) => (
            <OpacityWrapper key={i} isActive={i === current} left={i !== current && '13px'}>
              <Row wid="100%">
                <Row wid="180px">
                  <Text size="30px" med lineHt="110%">
                    {x.title}
                  </Text>
                </Row>

                <Row centerAll marg="3px 0 0 45px">
                  {current === i &&
                    sliderElements.map((x, i) => (
                      <Clickable onClick={() => handleChange(i)} key={i}>
                        <Dot selected={i === current} />
                      </Clickable>
                    ))}
                </Row>
              </Row>

              <Text marg="12px 0 0" size="24px" lineHt="32px">
                {x.content}
              </Text>

              <Button
                marg="30px 0 0"
                text={t('website.signUp')}
                website
                wid="178px"
                ht="54px"
                onClick={() => navigate('/signup')}
                textStyle={{
                  style: {
                    fontSize: 24
                  }
                }}
              />
            </OpacityWrapper>
          ))}
        </Col>
      )}
    </Col>
  );
};

export default FadeInSlider;
